import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Result, Spin } from 'antd';
import { apiRequest } from '../../shared/api/client.ts';

interface ResolveResponse {
  spaceId: string;
  itemId: string;
  displayKey: string;
}

/**
 * Короткая ссылка на карточку: `/c/:spaceSlug/:itemKey`.
 * Резолвит ключ через API и редиректит на полный URL пространства.
 */
export function ItemRedirectPage(): JSX.Element {
  const { spaceSlug, itemKey } = useParams<{ spaceSlug: string; itemKey: string }>();
  const [target, setTarget] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!spaceSlug || !itemKey) {
      setError('Некорректная ссылка');
      return;
    }
    apiRequest<ResolveResponse>(
      `/api/items/resolve-key?spaceSlug=${encodeURIComponent(spaceSlug)}&key=${encodeURIComponent(itemKey)}`,
    )
      .then((res) => {
        setTarget(`/s/${encodeURIComponent(spaceSlug)}?item=${encodeURIComponent(res.displayKey)}`);
      })
      .catch((err: any) => {
        if (err?.code === 'not_found') setError('Запись не найдена');
        else setError(err?.message ?? 'Не удалось открыть ссылку');
      });
  }, [spaceSlug, itemKey]);

  if (target) return <Navigate to={target} replace />;
  if (error) return <Result status="404" title="Не найдено" subTitle={error} />;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
      <Spin />
    </div>
  );
}
